import {
  Alert,
  AlertIcon,
  AlertTitle,
  Box,
  Heading,
  HStack,
  Icon,
  IconButton,
  Input,
  Stack,
  Tooltip,
} from '@chakra-ui/react';
import { useLocalazyKeyUrlMutation } from 'hooks/mutations/useLocalazyKeyUrlMutation';
import { useState } from 'react';
import { LuExternalLink } from 'react-icons/lu';

type Props = {
  locale: string;
};

export function LocalazyMenu({ locale }: Props) {
  const localazyKeyUrlMutation = useLocalazyKeyUrlMutation(locale);
  const [translationKeyInput, setTranslationKeyInput] = useState('');

  const errorMessage =
    localazyKeyUrlMutation.isError && localazyKeyUrlMutation.error
      ? localazyKeyUrlMutation.error.message ??
        localazyKeyUrlMutation.error.exception?.message ??
        'Error'
      : null;

  async function onOpenTranslationInLocalazy() {
    const search = translationKeyInput.trim();
    if (search === '') {
      return;
    }
    localazyKeyUrlMutation.mutate(
      { search },
      {
        onSuccess: (data) => {
          const url = data?.data?.url;
          if (url) {
            window.open(url, '_blank');
          }
          setTranslationKeyInput('');
        },
      },
    );
  }

  return (
    <Box mb={2} pt={2}>
      <Heading as="h2" fontSize="sm" mb={2}>
        {'Localazy'}
      </Heading>
      <Stack spacing={2}>
        <HStack w="100%" spacing={2}>
          <Input
            placeholder={'Translation or key'}
            size="sm"
            value={translationKeyInput}
            onChange={(e) => setTranslationKeyInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                void onOpenTranslationInLocalazy();
              }
            }}
            autoComplete="off"
            bg="gray.700"
            borderColor="gray.600"
            color="gray.100"
            _placeholder={{ color: 'gray.400' }}
          />
          <Tooltip label={'Open in Localazy'} placement="top" hasArrow>
            <IconButton
              aria-label={'Open in Localazy'}
              variant="ghost"
              color="gray.200"
              _hover={{ bg: 'gray.700' }}
              isDisabled={localazyKeyUrlMutation.isPending || translationKeyInput.trim() === ''}
              isLoading={localazyKeyUrlMutation.isPending}
              onClick={() => void onOpenTranslationInLocalazy()}
              size="sm"
              icon={<Icon as={LuExternalLink} />}
            />
          </Tooltip>
        </HStack>
        {errorMessage ? (
          <Alert status="error" size="sm" borderRadius="md">
            <AlertIcon />
            <AlertTitle fontSize="xs">{errorMessage}</AlertTitle>
          </Alert>
        ) : null}
      </Stack>
    </Box>
  );
}
